import React from "react";
import {Link} from "react-router-dom";
import {AddLangLink} from "../../../AdminPart/src/Constants";

function ChangeLink (props) {
            return (
                <Link className={props.className} to={AddLangLink()[props.lang]+ props.to}   style={props.style}>{props.children}</Link>
            )
}

export default ChangeLink
